// extracted by mini-css-extract-plugin
module.exports = {"header":"productFAQs_header__1Y3OY","faq":"productFAQs_faq__AZm5u","answer":"productFAQs_answer__S84OU"};